module.exports = __webpack_public_path__ + "img/02-5.58b05999.png";